module.exports = __webpack_public_path__ + "static/media/react1PropDrilling.d2e6e0e8.png";